const STORAGE_KEY = 'theme-mode'

export function initTheme() {
  document.documentElement.classList.remove('dark')
  localStorage.removeItem(STORAGE_KEY)
}
